"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIssueSummary = exports.getIssueRules = exports.getIgtSummary = void 0;
const igt_name_map_1 = __importStar(require("./igt-name-map"));
const types_1 = require("../types");
const getIgtSummary = (record, manifests, issues) => {
    // Return early if there are no manifests
    if (!Object.keys(manifests || {}).length) {
        return [];
    }
    const guides = Object.keys(igt_name_map_1.default).filter(igt => !types_1.deprecatedIgtTools.includes(igt));
    return guides.flatMap(guide => {
        const guideManifests = manifests[guide];
        const guideSummary = {
            tool: (0, igt_name_map_1.getIgtName)(guide),
            skipped: !!record.skipped_guides?.includes(guide)
        };
        // If the guide has not been run, include a placeholder guide summary
        if (!guideManifests?.length) {
            return {
                ...guideSummary,
                name: null,
                run: false
            };
        }
        // Add a guide summary for each of the guide runs
        return guideManifests.map(guideManifest => {
            const summary = {
                ...guideSummary,
                name: guideManifest.name || null,
                run: !!guideManifest.body?.metadata?.complete
            };
            if (summary.run) {
                const guidedIssues = issues.filter(issue => issue.manifestId === guideManifest.id);
                summary.issues = (0, exports.getIssueSummary)(guidedIssues, true);
                summary.duration = guideManifest.body?.metadata?.duration;
            }
            return summary;
        });
    });
};
exports.getIgtSummary = getIgtSummary;
const getIssueRules = (issues, onlyNeedsReview = false) => {
    const dictionary = {};
    issues.forEach(issue => {
        if (onlyNeedsReview && !issue.isNeedsReview) {
            return;
        }
        const rule = issue.rule;
        if (dictionary[rule]) {
            dictionary[rule].count++;
            return;
        }
        dictionary[rule] = {};
        dictionary[rule].count = 1;
        dictionary[rule].mode = issue.isManual ? 'manual' : 'automated';
    });
    const rules = [];
    for (const rule in dictionary) {
        rules.push({
            name: rule,
            count: dictionary[rule].count,
            mode: dictionary[rule].mode
        });
    }
    return rules;
};
exports.getIssueRules = getIssueRules;
const getIssueSummary = (issues, isIgt = false) => {
    const issueCount = {};
    issueCount.critical =
        issues.filter(issue => issue.impact === 'critical').length || 0;
    issueCount.serious =
        issues.filter(issue => issue.impact === 'serious').length || 0;
    issueCount.moderate =
        issues.filter(issue => issue.impact === 'moderate').length || 0;
    issueCount.minor =
        issues.filter(issue => issue.impact === 'minor').length || 0;
    if (isIgt) {
        return issueCount;
    }
    issueCount.bestPractices =
        issues.filter(issue => issue.isBestPractice).length || 0;
    issueCount.needsReview =
        issues.filter(issue => issue.isNeedsReview).length || 0;
    return issueCount;
};
exports.getIssueSummary = getIssueSummary;
//# sourceMappingURL=universal-format-utils.js.map